import { trigger, transition, state, style, animate } from '@angular/animations';

export const SECTION_ANIMATIONS = [
    trigger('sectionContent', [
        state('expanded', style({
            height: '*'
        })),
        state('shrunk', style({
            height: '0'
        })),
        transition('expanded <=> shrunk', animate('350ms'))
    ])
];
